import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export default function Members() {
  const navigate = useNavigate();
  const [member, setMember] = useState<{ email: string; name?: string } | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setMember(res.data))
      .catch(() => navigate("/login"))
      .finally(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signOut = async () => {
    await api.delete("/auth/session").catch(() => {});
    navigate("/");
  };

  return (
    <div data-testid="members-page" className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-xl px-6 pb-28 pt-36">
        {!checking && member && (
          <Reveal>
            <p className="font-oswald text-[11px] uppercase tracking-[0.4em] text-seaglass">
              Members
            </p>
            <h1 className="mt-4 font-garamond text-4xl text-ink sm:text-5xl">
              Welcome{member.name ? `, ${member.name.split(" ")[0]}` : ""}.
            </h1>
            <p className="mt-6 font-garamond text-lg leading-relaxed text-softblack/85">
              You are signed in as {member.email}. The member area is being
              prepared — you will be notified quietly when it opens.
            </p>
            <div className="mt-12">
              <button
                type="button"
                data-testid="member-sign-out"
                onClick={signOut}
                className="border border-ink px-10 py-4 font-oswald text-xs uppercase tracking-[0.35em] text-ink transition-colors duration-300 hover:bg-ink hover:text-paper"
              >
                Sign out
              </button>
            </div>
          </Reveal>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
